import { isValidEmail } from '@utils/commons';

const validateLoginEmail = (email: string) => {
  const value = email.trim();
  if (!value) {
    return 'Please enter your email address';
  }

  if (!isValidEmail(email)) {
    return 'Please enter a valid email address';
  }

  return '';
};

export default validateLoginEmail;
